import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface INSIGHTS_STATE_TYPE {
  unopenedData: Record<string, { data: UnopenedInsights; count: number }>;
  averageData: Record<string, AverageInsights>;
}

const INITIAL_STATE: INSIGHTS_STATE_TYPE = {
  unopenedData: {},
  averageData: {},
};

const insightSlice = createSlice({
  name: 'insights',
  initialState: INITIAL_STATE,
  reducers: {
    setUnopenedInsightData(
      state: INSIGHTS_STATE_TYPE,
      action: PayloadAction<Record<string, { data: UnopenedInsights; count: number }>>,
    ) {
      state.unopenedData = action.payload;
    },
    setAverageInsightData(
      state: INSIGHTS_STATE_TYPE,
      action: PayloadAction<Record<string, AverageInsights>>,
    ) {
      state.averageData = action.payload;
    },
  },
});

export const { setUnopenedInsightData, setAverageInsightData } = insightSlice.actions;

export default insightSlice.reducer;
